export const SET_STEP = "SET_STEP@ONBOARDING";
export const INCREMENT_STEP = "INCREMENT_STEP@ONBOARDING";
export const DECREMENT_STEP = "DECREMENT_STEP@ONBOARDING";



